import enUS from '../locales/en-US'
import zhCN from '../locales/zh-CN'
import { createI18n } from 'vue-i18n'

const i18n:any = createI18n({
 legacy: false,
  locale: 'en-US', // 默认语言
  fallbackLocale: 'en-US',
  missingWarn: false,
  fallbackWarn: false,
  messages: {
    'en-US': enUS,
    en: enUS,
    'zh-CN': zhCN,
    zh: zhCN,
  },
})

declare global {
  interface Window {
    i18n?: any
  }
}

window.i18n = i18n 
export default i18n
